<template>
  <div>
    <Navigation />
    <div class="wrap">
      <div class="head">
        <div><h1>Audit Log</h1><p class="lede">Every sensitive action, in order. Latest {{ rows.length }} events.</p></div>
        <button class="secondary" @click="load">Refresh</button>
      </div>
      <div class="card">
        <table>
          <thead>
            <tr><th style="width:150px">When</th><th>Who</th><th>Action</th><th>Entity</th><th>Details</th></tr>
          </thead>
          <tbody>
            <tr v-for="r in rows" :key="r.id">
              <td class="muted small">{{ r.created_at }}</td>
              <td>
                {{ r.user_name || 'system' }}
                <span v-if="r.user_role" :class="'badge ' + r.user_role" style="margin-left:6px">{{ r.user_role }}</span>
              </td>
              <td><code>{{ r.action }}</code></td>
              <td class="muted small">{{ r.entity_type || '—' }} {{ r.entity_id ? '#' + r.entity_id : '' }}</td>
              <td>
                <div v-if="r.before_value" class="diff">
                  <div class="diff-label">Before</div><pre>{{ pretty(r.before_value) }}</pre>
                </div>
                <div v-if="r.after_value" class="diff">
                  <div class="diff-label">After</div><pre>{{ pretty(r.after_value) }}</pre>
                </div>
                <div v-if="r.context" class="diff">
                  <div class="diff-label">Context</div><pre>{{ pretty(r.context) }}</pre>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <p v-if="!rows.length" class="muted center">No audit events yet.</p>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/paysol-nav/Navigation.vue';
import { paysol, execute } from '@/api';

export default {
  name: 'AuditLog',
  components: { Navigation },
  data() { return { rows: [] }; },
  async mounted() { await this.load(); },
  methods: {
    async load() {
      const { data } = await execute({ function: 'getAuditLog', limit: 200 }, paysol);
      if (data.success) this.rows = data.data;
    },
    pretty(v) { try { return JSON.stringify(typeof v === 'string' ? JSON.parse(v) : v, null, 2); } catch (e) { return String(v); } }
  }
};
</script>

<style scoped>
.wrap { max-width: 1300px; margin: 0 auto; padding: 24px; }
.head { display: flex; justify-content: space-between; align-items: end; margin-bottom: 20px; }
h1 { font-size: 26px; margin: 0 0 4px; }
.lede { color: var(--paysol-muted); margin: 0; }
.muted { color: var(--paysol-muted); } .small { font-size: 11px; }
.center { text-align: center; padding: 40px 0; }
code { background: var(--paysol-bg-elev); padding: 2px 6px; border-radius: 3px; font-size: 12px; color: var(--paysol-teal); }
.diff { margin-bottom: 6px; }
.diff-label { color: var(--paysol-muted); font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; }
.diff pre { background: var(--paysol-bg-elev); padding: 6px 10px; border-radius: 4px; font-size: 11px; margin: 2px 0; max-height: 120px; overflow: auto; white-space: pre-wrap; }
</style>
